var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99953 0.199986C8.29953 0.199986 7.59953 0.469985 7.06953 0.999985L0.549531 7.51999C0.259531 7.80999 0.259531 8.28999 0.549531 8.57999C0.839531 8.86999 1.31953 8.86999 1.60953 8.57999L8.12953 2.05999C8.60953 1.57999 9.38953 1.57999 9.86953 2.05999L16.3895 8.57999C16.6795 8.86999 17.1595 8.86999 17.4495 8.57999C17.7395 8.28999 17.7395 7.80999 17.4495 7.51999L10.9295 0.999985C10.3995 0.469985 9.69953 0.199986 8.99953 0.199986Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.c8e01992b1f7f1dba0dc82c85aa8d6e0.svg";
export { ForwardRef as ReactComponent };